import { schema } from 'normalizr';
import { customersSchema } from './Customer';
import { voicemailSchema } from './VoicemailSchema';

export const ENTITY_CALL_DISPOSITIONS = 'callDispositions';
const ENTITY_RECORDING = 'recordings';
export const ENTITY_CALL_LOGS = 'callLogs';
export const ENTITY_CALL_LOGS_LIST = 'callLogsList';

const callDispositionsSchema = new schema.Entity(
  ENTITY_CALL_DISPOSITIONS,
  {},
  { idAttribute: 'voice_call_log_uuid' },
);

const recordingSchema = new schema.Entity(ENTITY_RECORDING, {}, { idAttribute: 'uuid' });

export const callLogsSchema = new schema.Entity(
  ENTITY_CALL_LOGS,
  {
    customer: { data: customersSchema },
    call_disposition: { data: callDispositionsSchema },
    recording: { data: recordingSchema },
    voicemail: { data: voicemailSchema },
  },
  { idAttribute: 'uuid' },
);

export const callLogsListSchema = new schema.Entity(ENTITY_CALL_LOGS_LIST, { data: [callLogsSchema] });
